import { render } from "./CampusManagement.vue?vue&type=template&id=9bdf0bc4&scoped=true"
import script from "./CampusManagement.vue?vue&type=script&lang=js"
export * from "./CampusManagement.vue?vue&type=script&lang=js"

import "./CampusManagement.vue?vue&type=style&index=0&id=9bdf0bc4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bdf0bc4"]])

export default __exports__